import React, { Fragment } from 'react';

export default function IconBusiness(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.77049 4.48481C9.17235 4.08294 9.71739 3.85718 10.2857 3.85718H13.7143C14.2826 3.85718 14.8277 4.08294 15.2295 4.48481C15.6314 4.88667 15.8571 5.43171 15.8571 6.00004V7.28575H18.8571C20.0406 7.28575 21 8.24514 21 9.42861V18C21 19.1835 20.0406 20.1429 18.8571 20.1429H5.14286C3.95939 20.1429 3 19.1835 3 18V9.42861C3 8.24514 3.95939 7.28575 5.14286 7.28575H8.14286V6.00004C8.14286 5.43171 8.36862 4.88667 8.77049 4.48481ZM8.14286 8.14289H5.14286C4.43278 8.14289 3.85714 8.71853 3.85714 9.42861V18C3.85714 18.7101 4.43278 19.2858 5.14286 19.2858H8.14286V8.14289ZM9 19.2858V8.14289H15V19.2858H9ZM15.8571 19.2858H18.8571C19.5672 19.2858 20.1429 18.7101 20.1429 18V9.42861C20.1429 8.71853 19.5672 8.14289 18.8571 8.14289H15.8571V19.2858ZM15 7.28575H9V6.00004C9 5.65904 9.13546 5.33202 9.37658 5.0909C9.6177 4.84978 9.94472 4.71432 10.2857 4.71432H13.7143C14.0553 4.71432 14.3823 4.84978 14.6234 5.0909C14.8645 5.33202 15 5.65904 15 6.00004V7.28575Z"
        fill={
          props.bgded
            ? props.color
              ? props.color
              : props?.wl?.cor_texto_botao
            : props.color
            ? props.color
            : props?.wl?.cor_tema_secundaria
        }
      />
    </svg>
  );
}
